import { APP_PATH } from "../Layers/layerBasics";

// The insights articles: static pages outside the app (/uk/insights/<slug>, built from
// content/insights by scripts/insights/build_insights.py and served by nginx), so they're
// plain links (href), never router links. latest.json lists the 3 newest for the landing page.
export const INSIGHTS_PATH = APP_PATH + '/insights';
export const INSIGHTS_LATEST_URL = INSIGHTS_PATH + '/latest.json';
export const PRESS_PATH = APP_PATH + '/press';
export const insightUrl = (slug) => INSIGHTS_PATH + '/' + slug;

// Articles linked from the app's own pages
export const CITY_CENTRE_CRIME_INSIGHT = insightUrl('city-centre-crime-workday-population');

// The entries of latest.json the strip can show: only well-formed ones on our own paths, so a
// bad file shows nothing rather than a broken card
export const validInsights = (list) => (Array.isArray(list) ? list : [])
    .filter((a) => a && typeof a.title === 'string' && typeof a.url === 'string' && a.url.startsWith(INSIGHTS_PATH + '/')
        && (!a.image || (typeof a.image === 'string' && a.image.startsWith(INSIGHTS_PATH + '/'))))
    .slice(0, 3);

// A small link to an article at the foot of a map popup (popups are HTML strings). Opens in the
// same tab, as the area page links do; label and url are our own constants, never data.
export const insightLinkHTML = (url, label) =>
    '<a class="insightlink" href="'+url+'" style="display:inline-block;margin-top:6px;font-size:.78em;font-weight:600;'+
    'color:#1f7a5a;text-underline-offset:2px">'+label+' →</a>';
